import { useNavigate, Link } from "react-router-dom";
import useLogout from "../hooks/useLogout";
import useAuth from "../hooks/useAuth";
import { Container, Row, Col, Form } from 'react-bootstrap';
import 'boxicons/css/boxicons.min.css';
import TopBar from "../pages/Admin/TopBar";
import React, { useRef, useEffect, useState, useCallback } from "react";
import useAxiosPrivate from "../hooks/useAxiosPrivate";
import "./summeryTableStyle.css"



const ArthiksakhaDashboard = () => {
    const [errMsg, setErrMsg] = useState("");
    const errRef = useRef();
    const [sucssMsg, setSucssMsg] = useState("");
    const showMessage = (type, message) => {
        if (type === 'error') {
            setErrMsg(message);
            setSucssMsg(""); // ensure success message is cleared
        } else if (type === 'success') {
            setSucssMsg(message);
            setErrMsg(""); // ensure error message is cleared
        }

        // Auto-hide after 10 seconds
        setTimeout(() => {
            setErrMsg("");
            setSucssMsg("");
        }, 10000); // 10000ms = 10 seconds
    };

    const navigate = useNavigate();
    const logout = useLogout();
    const { auth } = useAuth();
    const [selectedArthiksakhaId, setSelectedArthiksakhaId] = useState("");
    const [arthiksakhaList, setArthiksakhaList] = useState([]);
    const [khandSummary, setKhandSummary] = useState([]);
    const axiosPrivate = useAxiosPrivate();
    const [loading, setLoading] = useState(true);
    const [ArthiksakhasCount, setArthiksakhasCount] = useState("");
    const [sthanCount, setSthanCount] = useState("");
    const [hasSearched, setHasSearched] = useState(false); // 👈 NEW


    const [errorMessage, setErrorMessage] = useState("");


    const UPDATE_DEFAULT_ARTHIK_SAKHA = "set-user-default-arthik-sakha";

    const [gurudakshinas, setGurudakshinas] = useState([]);

    const [error, setError] = useState(null);


    const signOut = async () => {
        await logout();
        navigate('/login');
    }


    const fetchArthiksakhaList = async () => {
        try {
            const response = await axiosPrivate.get('list-user-arthik-sakhas');
            setArthiksakhaList(response.data);
            setArthiksakhasCount(response.data.length)
            // setArthiksakhasCount
            // Set the default dropdown value to the first arthik_sakha_id if available
            if (response.data.length > 0) {
                setSelectedArthiksakhaId(response.data[0].arthik_sakha_id);
                setSthanCount(response.data[0].sthans);
            }
        } catch (error) {
            console.error("Error fetching arthiksakha list:", error);
        }
    };

    const fetchArppanSummary = useCallback(async () => {
        if (!selectedArthiksakhaId) return;  // 🛑 Prevent API call if undefined or empty
        setLoading(true);
        setError(null);
        setHasSearched(true);
        try {
            const url = `get-arthiksakha-arppan-summary?arthik_sakha_id=${selectedArthiksakhaId}`;
            const response = await axiosPrivate.get(url, { withCredentials: true });
            setLoading(false);
            if (response.status === 204) {
                // ✅ No Content case
                setGurudakshinas([]);
                setLoading(false);
                setError("No Data available.");
                return;
            }

            // ✅ Handle valid data
            // setGurudakshinas(Array.isArray(response.data) ? response.data : []);
            setGurudakshinas(response.data);


        } catch (error) {
            console.error("Error fetching Data:", error);
            setError(error?.response?.data?.message || "No Data available.");
            setGurudakshinas([]); // Clear old data in case of error
            setLoading(false);
        }
    }, [axiosPrivate, selectedArthiksakhaId]);

    const summaryData = gurudakshinas?.data || [];

    const vs = summaryData.find(item => item.sakha === "Vidyarthi Samyuktha");
    const vt = summaryData.find(item => item.sakha === "Vidyarthi Tharuna");
    const vy = summaryData.find(item => item.sakha === "Vyavasayi Tharuna");
    const pr = summaryData.find(item => item.sakha === "Prouda");


    useEffect(() => {
        fetchArppanSummary();
    }, [selectedArthiksakhaId]);


    useEffect(() => {
        fetchArthiksakhaList();
    }, []);

    const handleSubmit = async (e) => {
        e.preventDefault();
        if (!selectedArthiksakhaId) {
            setErrorMessage("Please select a Arthiksakha.");
            return;
        } else {
            setErrorMessage(""); // clear any previous error

            try {
                var data = JSON.stringify({
                    arthik_sakha_id: selectedArthiksakhaId,
                    setDefault: true
                });

                const response = await axiosPrivate.post(UPDATE_DEFAULT_ARTHIK_SAKHA, data, {
                    headers: { "Content-Type": "application/json" },
                    withCredentials: true,
                });

                showMessage('success', response?.data?.message);
                // ✅ Redirect after successful update
                if (response?.status === 200) {
                    // Example URL — change this to your desired path
                    window.location.href = "/ArthiksakhaDashboard/";
                }

            } catch (err) {
                if (!err?.response) {
                    setErrMsg("No Server Response");
                } else if (err.response?.data?.message) {
                    const errorMsg = typeof err.response.data.message === 'string'
                        ? err.response.data.message
                        : err.response.data.message.msg || "Unknown error"; // Extract inner msg if object
                    setErrMsg(errorMsg);
                } else {
                    setErrMsg("Registration Failed");
                }
                errRef.current.focus();
            }
        }


    };

    return (

        <Container>

            <section className="adminsec">

                <div className="d-flex justify-content-end align-items-center gap-2 mb-3">
                    <button onClick={() => navigate("/arthiksakha/list/KhandSummary")} className="btn btn-warning newviewbtn">Khand Summary</button>

                    <button
                        type="button"
                        className="btn btn-warning ms-auto newviewbtn"
                        onClick={() => navigate("/arthiksakha/list/SthanSummary")}
                    >
                        Sthan Summary
                    </button>
                </div>

                {/* <div className="center-image">

                    <img src="/images/newlogo.png" width="20%" className='' />
                </div> */}
                {/* <h1 className="adminhead">Dashbord</h1> */}

                <center><h2 className="dashwel">Namaste <span className="colorChange">{auth?.name}</span> !</h2> </center>
                <center><p className="dashwel">Welcome to <span className="colorChange">{auth?.level_name}</span> </p> </center>
                {/* <p className="adminuse">Welcome {auth?.name} !</p> */}

                <Row>
                    <Col md={2}></Col>
                    <Col md={8}>
                        <div className="dashnewdiv">
                            <Row>
                                <Col md={6} className="dashnewsub">
                                    <i className="bx bx-lock dashtabicon"></i> Arthiksakhas Assigned - {ArthiksakhasCount}
                                </Col>
                                <Col md={6} className="dashnewsub">
                                    <i className="bx bx-lock-open dashtabicon"></i> Sthans in {auth?.level_name} Arthiksakha - {sthanCount}
                                </Col>
                            </Row>
                            {/* <table className="dashtab">
                                <tbody>
                                    <tr>
                                        <td className="dashsthan dashsthan2"><i className="bx bx-lock dashtabicon"></i> Arthiksakhas Assigned - {ArthiksakhasCount}</td>
                                        <td className="dashsthan dashsthan2"><i className="bx bx-lock-open dashtabicon"></i> Sthans in Selected Arthiksakha - {sthanCount} </td>
                                    </tr>
                                </tbody>
                            </table> */}
                        </div>
                    </Col>
                    <Col md={2}></Col>
                </Row>
                <Row className="spclrow">
                    <Form onSubmit={handleSubmit}>
                        <Form.Group controlId="arthiksakhaDropdown" className="mb-3">
                            <Form.Label>Select Arthiksakha</Form.Label>

                            <Form.Control
                                as="select"
                                value={selectedArthiksakhaId}
                                onChange={(e) => setSelectedArthiksakhaId(e.target.value)}
                                className="vibhaglist"
                            >
                                {arthiksakhaList.map((arthiksakha) => (
                                    <option
                                        key={arthiksakha.arthik_sakha_id}
                                        value={arthiksakha.arthik_sakha_id}
                                    >
                                        {arthiksakha.arthik_sakha}
                                    </option>
                                ))}
                            </Form.Control>
                            <div className="text-center mt-3">
                                <button type="submit" className="btn newpagebtn">
                                    Chnage Default Arthiksakha
                                </button>
                            </div>
                        </Form.Group>
                    </Form>
                </Row>

                <Row className="justify-content-center">
                    {hasSearched && (
                        <div className="table-container">
                            {hasSearched && (
                                <table id="customers" className="table table-bordered text-center summary-table">
                                    <thead>
                                        <tr>
                                            <th colSpan={1} className="text-center">
                                                SHRENI
                                            </th>
                                            <th colSpan={5} className="text-center">
                                                UPASTHITHI/THUKA
                                            </th>
                                        </tr>
                                        <tr>
                                            <th rowSpan={2}></th>
                                            <th>VIDHYARTHI SAMYUKTHA</th>
                                            <th>VIDHYARTHI THARUNA</th>
                                            <th>VYAVASAYI THARUNA</th>
                                            <th>PROUDA</th>
                                            <th>TOTAL</th>
                                        </tr>
                                        <tr>
                                            <th>({gurudakshinas?.vs_uthsavam ?? 0})</th>
                                            <th>({gurudakshinas?.vt_uthsavam ?? 0})</th>
                                            <th>({gurudakshinas?.vy_uthsavam ?? 0})</th>
                                            <th>({gurudakshinas?.pr_uthsavam ?? 0})</th>
                                            <th>({gurudakshinas?.uthsavam ?? 0})</th>
                                        </tr>
                                    </thead>

                                    <tbody><tr>
                                        <th>SISU</th>

                                        <td>
                                            <div>{vs?.sisu ?? 0}</div>
                                            <div className="amount">
                                                ₹{Number(vs?.sisuAmount ?? 0).toLocaleString("en-IN")}
                                            </div>
                                        </td>

                                        <td>
                                            <div> {vt?.sisu ?? 0}</div>
                                            <div className="amount">
                                                ₹{Number(vt?.sisuAmount ?? 0).toLocaleString("en-IN")}
                                            </div>



                                        </td>

                                        <td>

                                            <div> {vy?.sisu ?? 0}</div>
                                            <div className="amount">
                                                ₹{Number(vy?.sisuAmount ?? 0).toLocaleString("en-IN")}
                                            </div>


                                        </td>

                                        <td>
                                            <div> {pr?.sisu ?? 0}</div>
                                            <div className="amount">
                                                ₹{Number(pr?.sisuAmount ?? 0).toLocaleString("en-IN")}
                                            </div>



                                        </td>

                                        <td>
                                            {(vs?.sisu ?? 0) +
                                                (vt?.sisu ?? 0) +
                                                (vy?.sisu ?? 0) +
                                                (pr?.sisu ?? 0)}
                                            <br />
                                            ₹
                                            {(
                                                Number(vs?.sisuAmount ?? 0) +
                                                Number(vt?.sisuAmount ?? 0) +
                                                Number(vy?.sisuAmount ?? 0) +
                                                Number(pr?.sisuAmount ?? 0)
                                            ).toLocaleString("en-IN")}
                                        </td>
                                    </tr>
                                        <tr>
                                            <th>BALA</th>

                                            <td>
                                                {vs?.bala ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vs?.balaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vt?.bala ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vt?.balaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vy?.bala ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vy?.balaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {pr?.bala ?? 0}
                                                <div className="amount">
                                                    ₹{Number(pr?.balaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {(vs?.bala ?? 0) +
                                                    (vt?.bala ?? 0) +
                                                    (vy?.bala ?? 0) +
                                                    (pr?.bala ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.balaAmount ?? 0) +
                                                    Number(vt?.balaAmount ?? 0) +
                                                    Number(vy?.balaAmount ?? 0) +
                                                    Number(pr?.balaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>VIDHYARTHI THARUNA</th>

                                            <td>
                                                {vs?.vtharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vs?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vt?.vtharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vt?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vy?.vtharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vy?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {pr?.vtharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(pr?.vtharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {(vs?.vtharuna ?? 0) +
                                                    (vt?.vtharuna ?? 0) +
                                                    (vy?.vtharuna ?? 0) +
                                                    (pr?.vtharuna ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.vtharunaAmount ?? 0) +
                                                    Number(vt?.vtharunaAmount ?? 0) +
                                                    Number(vy?.vtharunaAmount ?? 0) +
                                                    Number(pr?.vtharunaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>
                                        </tr>

                                        <tr>
                                            <th>VYAVASAYI THARUNA</th>

                                            <td>
                                                {vs?.tharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vs?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vt?.tharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vt?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vy?.tharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vy?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {pr?.tharuna ?? 0}
                                                <div className="amount">
                                                    ₹{Number(pr?.tharunaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {(vs?.tharuna ?? 0) +
                                                    (vt?.tharuna ?? 0) +
                                                    (vy?.tharuna ?? 0) +
                                                    (pr?.tharuna ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.tharunaAmount ?? 0) +
                                                    Number(vt?.tharunaAmount ?? 0) +
                                                    Number(vy?.tharunaAmount ?? 0) +
                                                    Number(pr?.tharunaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>PROUDA</th>

                                            <td>
                                                {vs?.prouda ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vs?.proudaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vt?.prouda ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vt?.proudaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {vy?.prouda ?? 0}
                                                <div className="amount">
                                                    ₹{Number(vy?.proudaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {pr?.prouda ?? 0}
                                                <div className="amount">
                                                    ₹{Number(pr?.proudaAmount ?? 0).toLocaleString("en-IN")}
                                                </div>
                                            </td>

                                            <td>
                                                {(vs?.prouda ?? 0) +
                                                    (vt?.prouda ?? 0) +
                                                    (vy?.prouda ?? 0) +
                                                    (pr?.prouda ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.proudaAmount ?? 0) +
                                                    Number(vt?.proudaAmount ?? 0) +
                                                    Number(vy?.proudaAmount ?? 0) +
                                                    Number(pr?.proudaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>
                                        </tr>
                                        <tr>
                                            <th>TOTAL</th>

                                            <td>
                                                {(vs?.sisu ?? 0) +
                                                    (vs?.bala ?? 0) +
                                                    (vs?.vtharuna ?? 0) +
                                                    (vs?.tharuna ?? 0) +
                                                    (vs?.prouda ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.sisuAmount ?? 0) +
                                                    Number(vs?.balaAmount ?? 0) +
                                                    Number(vs?.vtharunaAmount ?? 0) +
                                                    Number(vs?.tharunaAmount ?? 0) +
                                                    Number(vs?.proudaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td>
                                                {(vt?.sisu ?? 0) +
                                                    (vt?.bala ?? 0) +
                                                    (vt?.vtharuna ?? 0) +
                                                    (vt?.tharuna ?? 0) +
                                                    (vt?.prouda ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vt?.sisuAmount ?? 0) +
                                                    Number(vt?.balaAmount ?? 0) +
                                                    Number(vt?.vtharunaAmount ?? 0) +
                                                    Number(vt?.tharunaAmount ?? 0) +
                                                    Number(vt?.proudaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td>
                                                {(vy?.sisu ?? 0) +
                                                    (vy?.bala ?? 0) +
                                                    (vy?.vtharuna ?? 0) +
                                                    (vy?.tharuna ?? 0) +
                                                    (vy?.prouda ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vy?.sisuAmount ?? 0) +
                                                    Number(vy?.balaAmount ?? 0) +
                                                    Number(vy?.vtharunaAmount ?? 0) +
                                                    Number(vy?.tharunaAmount ?? 0) +
                                                    Number(vy?.proudaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td>
                                                {(pr?.sisu ?? 0) +
                                                    (pr?.bala ?? 0) +
                                                    (pr?.vtharuna ?? 0) +
                                                    (pr?.tharuna ?? 0) +
                                                    (pr?.prouda ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(pr?.sisuAmount ?? 0) +
                                                    Number(pr?.balaAmount ?? 0) +
                                                    Number(pr?.vtharunaAmount ?? 0) +
                                                    Number(pr?.tharunaAmount ?? 0) +
                                                    Number(pr?.proudaAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>

                                            <td>
                                                {(vs?.totalUpasthith ?? 0) +
                                                    (vt?.totalUpasthith ?? 0) +
                                                    (vy?.totalUpasthith ?? 0) +
                                                    (pr?.totalUpasthith ?? 0)}
                                                <br />
                                                ₹
                                                {(
                                                    Number(vs?.totalAmount ?? 0) +
                                                    Number(vt?.totalAmount ?? 0) +
                                                    Number(vy?.totalAmount ?? 0) +
                                                    Number(pr?.totalAmount ?? 0)
                                                ).toLocaleString("en-IN")}
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            )}
                        </div>
                    )}
                </Row>
            </section>
            <TopBar />
        </Container>
    )
}

export default ArthiksakhaDashboard
